import React from "react";
import {
  IonModal,
  IonLabel,
  IonCol,
  IonButton,
  IonText
} from "@ionic/react";
import "./CustomModal.scss";
import DOMPurify from 'isomorphic-dompurify';
interface CustomModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  buttons: any;
  size?: string;
  footer?: any;
  children?: React.ReactNode;
  modalFade?:boolean;
}

const CustomModal: React.FC<any> = (props: CustomModalProps) => {
  const { isOpen, title, message, buttons, footer,modalFade} = props;

  const createMarkup = (content : any) => {
    const clean = DOMPurify.sanitize(content);
    return {__html: clean};
  }

  return (
    <IonModal
      isOpen={isOpen}
      cssClass={`custom-modal ${props.size ? props.size : ""}`}
      backdropDismiss={modalFade?modalFade:false}
      data-testid="ionmodal"
    >
      {title && (
        <header className="custom-modal-header">
          <IonLabel className="custom-modal-title" color="dark">
            {title}
          </IonLabel>
        </header>
      )}
      {message && (
        <section>
          <IonText className="custom-modal-message">
            <div dangerouslySetInnerHTML={createMarkup(message)}></div>
          </IonText>
        </section>
      )}
      {props.children && (
        <section className="custom-modal-content">{props.children}</section>
      )}
      {buttons && (
        <footer>
          {buttons.map((button: any, index: number) => {
            return (
              <IonCol key={`${title}_${index}`}>
                <IonButton
                  class={`btn load-btn ${button.type ? button.type : ""}`}
                  data-test={`${button.label?.toLowerCase()}-btn`}
                   disabled={
                    button && button.isDisabled ? button.isDisabled : false
                  }
                  onClick={button.callback}
                >
                  {button.label}
                </IonButton>
              </IonCol>
            );
          })}
        </footer>
      )}
       {footer && (
          <div className="custom-modal-footer">
             {footer()}
          </div>
        )}
    </IonModal>
  );
};

export default CustomModal;
